'use client';
import { createContext, useContext, useMemo } from 'react';
import { useEventCallback } from 'usehooks-ts';
var OpenAPIOperationContext = createContext({
    onOpenClient: function () { },
});
/**
 * Provider for the OpenAPIOperationContext.
 */
export function OpenAPIOperationContextProvider(props) {
    var children = props.children;
    var onOpenClient = useEventCallback(function (pointer) {
        var _a;
        (_a = props.onOpenClient) === null || _a === void 0 ? void 0 : _a.call(props, pointer);
    });
    var value = useMemo(function () { return ({ onOpenClient: onOpenClient }); }, [onOpenClient]);
    return (<OpenAPIOperationContext.Provider value={value}>
            {children}
        </OpenAPIOperationContext.Provider>);
}
/**
 * Hook to access the OpenAPIOperationContext.
 */
export function useOpenAPIOperationContext() {
    return useContext(OpenAPIOperationContext);
}
